module.exports = __webpack_public_path__ + "public/Icons/darkModeOn.svg?6377d816";